import type { LiteralUnion } from 'type-fest';

import type { SubEnvironment } from '@change-corgi/core/environment';

function getOrigin(env: LiteralUnion<SubEnvironment, string>): string {
	// eslint-disable-next-line @change-corgi/no-static-asset-url
	if (env === 'production' || env === 'development' || !env) return 'https://static.change.org';
	if (env === 'staging') return 'https://static.staging-change.org';
	return `https://static.${env}.changeeng.org`;
}

export function getStaticAssetUrl(env: LiteralUnion<SubEnvironment, string>, pathname: string): string {
	return `${getOrigin(env)}${pathname}`;
}
